import React from 'react'
import { useGLTF } from '@react-three/drei'

export function PowernomSkin(pos) {
  const { nodes, materials } = useGLTF('/models/psu2-transformed.glb')
  return (
    <group position={[pos[0], pos[1], pos[2] + 1.9]} dispose={null} rotation={[Math.PI/2,0,0]}>
       <mesh geometry={nodes['socket_head_cap_screw_iso_ISO_4762_M3_x_6_-_6NA2-70221'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['socket_head_cap_screw_iso_ISO_4762_M3_x_6_-_6NA2-70221_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/psu2-transformed.glb')
